// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperBrowserPreviewList-cls1_obB","cls2":"PaperBrowserPreviewList-cls2_xY2 PaperBrowserPreviewList-cls1_obB"};